import { render } from "./FileUploader2.vue?vue&type=template&id=759648f6"
import script from "./FileUploader2.vue?vue&type=script&lang=js"
export * from "./FileUploader2.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__